"use strict"
exports.__esModule = true;
exports.SimplybuiltIconConfig = {
  name: 'SimplybuiltIcon',
  height: 512,
  width: 512,
  svgPath: 'M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z',
  yOffset: 0,
  xOffset: 0,
};
exports.SimplybuiltIcon = require('../createIcon').createIcon(exports.SimplybuiltIconConfig);
exports["default"] = exports.SimplybuiltIcon;